'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = getSize;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _md = require('md5');

var _md2 = _interopRequireDefault(_md);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _isRetina = require('is-retina');

var _isRetina2 = _interopRequireDefault(_isRetina);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_RETINA = (0, _isRetina2.default)();

function getSize(small, retina) {
  var size = small ? 35 : 60;
  return retina ? size * 2 : size;
}

var styles = '\n  border-radius: 50%;\n';

function gravatarUrl(_ref) {
  var email = _ref.email,
      small = _ref.small;

  var id = (0, _md2.default)(email);
  var size = getSize(small, IS_RETINA);
  return 'https://secure.gravatar.com/avatar/' + id + '?s=' + size + '&d=404';
}

var Image = (0, _decisivUiUtils.buildStyledComponent)('Image', _styledComponents2.default.img.attrs({
  alt: 'user-avatar',
  src: gravatarUrl,
  width: '100%'
}), styles);

Image.propTypes = {
  email: _propTypes2.default.string,
  small: _propTypes2.default.bool
};

Image.defaultProps = {
  email: '',
  small: false
};

exports.default = Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Avatar/Image.js
// module id = 1533
// module chunks = 2